import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useEffect, useRef } from 'react'

import { useStudentEnrollmentValidationContext } from './context'
import { Steps } from './enums'

const STEP_CLOSE_EVENT: Partial<Record<Steps, string>> = {
  [Steps.ACADEMIC_DATA]: 'UserAccount.StudentAcademicFormClosed',
  [Steps.UPLOAD_INSTRUCTIONS]: 'UserAccount.StudentEnrollmentProofClosed',
  [Steps.DOCUMENT_PREVIEW]: 'UserAccount.StudentEnrollmentProofPreviewClosed',
  [Steps.ENROLLMENT_ERROR]: 'UserAccount.StudentEnrollmentProofFailedClosed',
}

// The provider unmounts only when the modal closes (a step change keeps it
// mounted), so this cleanup fires once and the last step is the dismissed screen.
export function EnrollmentCloseTracker() {
  const { currentStep, sharedData, eventData, viewer } = useStudentEnrollmentValidationContext()
  const stateRef = useRef({ currentStep, sharedData, eventData, viewer })
  stateRef.current = { currentStep, sharedData, eventData, viewer }

  useEffect(() => {
    return () => {
      const { currentStep, sharedData, eventData, viewer } = stateRef.current
      const name = STEP_CLOSE_EVENT[currentStep]
      if (!name) {
        return
      }

      const metadata: Record<string, unknown> = { ...eventData?.metadata }
      if (currentStep === Steps.ACADEMIC_DATA) {
        metadata.filledFieldsCount = [
          sharedData.institution?.trim(),
          sharedData.enrollmentPeriod,
          sharedData.termsAccepted,
        ].filter(Boolean).length
      }

      const pid = viewer?.pid
      sendMetrics(name, pid != null ? `${pid}` : null, { ...eventData, metadata })
    }
  }, [])

  return null
}
